import PluginRegistry from "../../pluginsInfrastructure/PluginRegistry";
import {
  ComponentToBeRegistered,
  Placeholder,
  PlaceholderPlugin,
  PluginEnableContext,
} from "../../pluginsInfrastructure/PluginRegistryTypes";
import loadable from "@loadable/component";
import { PriceInfoProps } from "./ShippingCalculator/PriceInfo";
import { SwanStyleSheetKey } from "@vp/swan";
import { productAdjacementInformation } from "../pluginOwners";

export const ShippingCalculatorComponent: ComponentToBeRegistered<PriceInfoProps> = {
  placeholder: Placeholder.Pricing,
  Component: loadable(() => import("./ShippingCalculator/PriceInfo")),
  name: "ShippingCalculator",
  styleNeeds: [
    "button",
    "icon",
    "modalDialog",
    "popover",
    "pricing",
    "selectionSet",
  ] as SwanStyleSheetKey[],
  enable: (context: PluginEnableContext, parentComponents: string[]) => {
    return true;
  },
};

export const shippingCalculator: PlaceholderPlugin = {
  init(pluginRegistry: PluginRegistry) {
    pluginRegistry.addComponent(this, ShippingCalculatorComponent);
  },
  pluginOwner: productAdjacementInformation,
};
